import { useEffect, useState, useRef } from 'react'
import React from 'react'

import { Input, IconInputWrapper, IconEye, IconPassword } from '../../Styled'

interface PasswordInputProps {
  name?: string
  value?: string
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  [key: string]: any
}

export default function PasswordInput({ name, value, onChange, onBlur, ...props }: PasswordInputProps) {
  const [visible, setVisible] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)

  function handleToggleVisible() {
    setVisible(!visible)
    inputRef.current?.focus()
  }

  useEffect(() => {}, [])

  return (
    <IconInputWrapper>
      <IconPassword className="input-icon" alt="" />
      <IconEye className={visible ? 'visible' : ''} onClick={handleToggleVisible}></IconEye>
      <Input
        ref={inputRef}
        type={visible ? 'text' : 'password'}
        name={name}
        placeholder="请输入取款密码"
        maxLength={4}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
      ></Input>
    </IconInputWrapper>
  )
}
